const properties = {
    apiBaseUrl: 'https://accounts.google.com/o/oauth2/auth/', // URL base del backend
    oauth: {
      google: {
        apiUrl: '/api/oauth2/authorization/google' 
      },
      facebook: {
        apiUrl: '/api/oauth2/authorization/facebook' 
      },
      x: {
        apiUrl: '/api/oauth2/authorization/twitter' 
      },
    },
  };
  
  export default properties;
  